import CryptoJS from 'crypto-js';

function sha256(content) {
    return CryptoJS.SHA256(content).toString(CryptoJS.enc.Hex);
}

export interface EventData {
    page_title: string;
    transaction_info?: {
        transaction_step?: string;
        transaction_id?: string;
    };
    user_info?: {
        user_id?: string;
        user_login_status?: string;
        user_return_status?: string;
    };
    time_elapsed?: number;
}

export const generateEventData = (data: EventData): void => {
    const { transaction_info, user_info, ...rest } = data;
    window.dataLayer = window.dataLayer || [];
    if (user_info?.user_id) {
        user_info.user_id = sha256(user_info.user_id);
    }
    window.dataLayer.push({
        event: 'v_page_info',
        page_info: {
            page_location: window.location.href,
            agency: 'Transport for NSW',
            product_team: 'Grants and Rebates',
            ...rest,
        },
        transaction_info: {
            transaction_name: 'Toll Relief Registration',
            transaction_type: 'register',
            ...transaction_info,
        },
        user_info: {
            ...user_info,
        },
    });
};
